import React from 'react';
import PropTypes from 'prop-types';

/**
 * Image Component:
 *  - Exports an img tab with some default attributes.
 */
export function Image(props) {
  return <img alt={props.alt} {...props} />;
}

Image.propTypes = {
  /**
   * The url for the source of image
   */
  src: PropTypes.string,
  /**
   * The description for the image
   */
  alt: PropTypes.string,
  /**
   * The object to setup inline styles for the tag.
   */
  style: PropTypes.object,
  /**
   * The string to be set as aria-label
   */
  ariaLabel: PropTypes.string,
  /**
   * The callback function to be called when clicked on the tag
   */
  onClick: PropTypes.func,
  /**
   * The string to be set as className
   */
  className: PropTypes.string,
  /**
   * The boolean value to control if the image is draggable
   */
  draggable: PropTypes.bool,
  /**
   * tabIndex to set on element
   */
  tabIndex: PropTypes.number,
};

Image.defaultProps = {
  draggable: false,
};
